module.exports = __webpack_public_path__ + "media/images/qr/graphic-qr-mono-aa2f1faa09009295b85e90d2c81713c9.svg";